export type SoldierType = 'King' | 'Knight' | 'Archer' | 'Crossbow' | 'Healer' | 'Siege Equipment';

export type Team = 'raiders' | 'defenders';

export interface Soldier {
  id: string;
  type: SoldierType;
}

export interface SiegeEquipment extends Soldier {
  type: 'Siege Equipment';
  manning: string[]; // IDs of soldiers manning this equipment (max 4)
}

export interface Army {
  king: Soldier | null;
  knights: Soldier[];
  archers: Soldier[];
  crossbows: Soldier[];
  healers: Soldier[];
  siegeEquipment: SiegeEquipment[];
}

export interface Player {
  id: string;
  name: string;
  team: Team;
  raidPoints: number;
  raidPointsSpent: number;
  army: Army;
  userId?: string; // Auth0 user ID (sub claim) for linking to authenticated users
}

export interface UnitStats {
  type: SoldierType;
  hp: number;
  damage: number;
  cost: number;
  imageUrl?: string;
}

export interface GameState {
  players: Player[];
  unitStats: Record<SoldierType, UnitStats>;
  battlefieldBackgroundUrl?: string;
  kingRaidersImageUrl?: string;
  kingDefendersImageUrl?: string;
}

export const SOLDIER_COST = 5;
export const SIEGE_EQUIPMENT_COST = 20;
export const SIEGE_EQUIPMENT_CREW_SIZE = 4;

export const DEFAULT_UNIT_STATS: Record<SoldierType, UnitStats> = {
  'King': { type: 'King', hp: 100, damage: 20, cost: 0 },
  'Knight': { type: 'Knight', hp: 80, damage: 15, cost: 5 },
  'Archer': { type: 'Archer', hp: 50, damage: 12, cost: 5 },
  'Crossbow': { type: 'Crossbow', hp: 50, damage: 18, cost: 5 },
  'Healer': { type: 'Healer', hp: 60, damage: 5, cost: 5 },
  'Siege Equipment': { type: 'Siege Equipment', hp: 120, damage: 40, cost: 20 }
};
